export const firstLetter = (str?: string) => (str || "").substr(0, 1);

export const isEmptyString = (str?: string) =>
  str === null || str === undefined || str.length === 0 || str.trim().length === 0;
